import { ContentTable } from "pdfmake/interfaces";
import { BallotReport } from "./ballot-report";
import { CiVoteId } from "../ci/ci-vote";


export class CiBallotReport extends BallotReport {
  override committeeVoteColumns: string[] = [
    'Committee Member',
    'Organisation',
    'Role',
    'Country',
    'Voting Rights',
    'Vote'
  ];

  override ballotVoteResultColumns: string[] = [
    'Ballot Result',
    'Total',
    CiVoteId.AGREE,
    CiVoteId.DISAGREE,
    CiVoteId.NO_RESPONSE
  ];

  constructor() {
    super();
  }

  override generateBallotVoteResultBreakdownTable(): ContentTable | null {
    let content = super.generateBallotVoteResultBreakdownTable();
    if (content) {
      content.table.widths = ['20%', '10%', '23.33%', '23.33%', '23.33%'];
    }

    return content;
  }

  override generateCommitteeVotesTable(): ContentTable | null {
    let content = super.generateCommitteeVotesTable();
    if (content) {
      content.table.widths = ['20%', '30%', '15%', '10%', '9%', '16%'];
    }

    return content;
  }

  override generateQuestionTable(): ContentTable | null {
    return null;
  }
}
